
import { useTranslation } from 'react-i18next';
import styles from '../../Components/Bookings/Bookings.module.css';
import upArrow from "../../Images/up.png";
import offerImg from "../../Images/offer.png";
import BillLine from '../../Components/Bookings/BillLine';
import downArrow from "../../Images/down.png";
import BookBaqa from '../../Components/Bookings/BookBaqa';
import { useEffect, useState } from 'react';
import BookService from '../../Components/Bookings/BookService';
import BookingSelect from '../../Components/Utilities/BookingSelect'
import { useDispatch, useSelector } from 'react-redux';
import { getReservationService } from '../../redux/Slices/reservation/thunk';
import { getSettings } from '../../redux/Slices/users/thunk';


export default function UserBookingsPage() {

    const { t, i18n } = useTranslation();
    const[selectedService,setSelectedService]=useState('packages');
    const[packageLength,setPackageLength]=useState();
    const[servicesLength,setServicesLength]=useState();
    const user = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(getSettings())
  })
 

    const toggleShow = ({ id, img }) => {
        const toggleElement = window.document.getElementById(id);

        console.log(toggleElement);

        if (toggleElement.style.display == 'block' || toggleElement.style.display == '') {
            document.getElementById(img).src = downArrow;
        }
        else {
            document.getElementById(img).src = upArrow;
        }

        toggleElement.style.display = toggleElement.style.display == 'none' ? 'block' : 'none';



    }
    return (   

        <div className='container flex-grow-1'>
            <div className={styles.loginContainer}>

                <div className={`${styles.loginHeader} my-3`}>{t("myBookings")}</div>

                <div className={`my-2 d-flex justify-content-center ${styles.togelWidth}`}>
                <BookingSelect setSelectedService={setSelectedService} packageLength={packageLength} servicesLength={servicesLength} />

                </div>
                
               { selectedService=='packages' && <BookBaqa toggleShow={toggleShow} setPackageLength={setPackageLength} setServicesLength={setServicesLength} /> } 
               { selectedService=='services' && <BookService toggleShow={toggleShow} setServicesLength={setServicesLength}/>}

            </div>
        </div>
    )
}
